module.exports = __webpack_public_path__ + "media/button.5a82cd02.mp3";